import {Component, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DividerModule} from "primeng/divider";
import {DatasetDinamicoService} from "../../../services/dataset-dinamico.service";
import {ISisbenConsultaResponse} from "../../../shared/interface/consultaSisben";
import {Router} from "@angular/router";
import {
  BuscarSisbenComponent,
  ButtonColumnType,
  CustomTableComponent,
  CustomTitle,
  DataColumnType,
  ICustomTable, ISettings,
  IsearchJefeHogar, LoadingPanelService
} from "lib-base";
import {TipoIdentificacionService} from "../../../../../../tramitantes/src/app/services/tipoIdentificacion.service";
import {ITipoIdentificacion} from "../../../../../../tramitantes/src/app/shared/interfaces/seguridad";

@Component({
  selector: 'app-consulta-sisben',
  standalone: true,
  imports: [CommonModule, DividerModule, CustomTitle, BuscarSisbenComponent, CustomTableComponent],
  templateUrl: './consulta-sisben.component.html',
  styleUrl: './consulta-sisben.component.scss'
})
export class ConsultaSisbenComponent implements OnInit, AfterViewInit {

  responses: ISisbenConsultaResponse[] = [];
  tiposIdentificaciones: ITipoIdentificacion[] = [];
  configTable!: ICustomTable;


  @ViewChild(BuscarSisbenComponent, {static: true}) buscarComponent!: BuscarSisbenComponent;
  @ViewChild(CustomTableComponent) customTableComponent!: CustomTableComponent;


  constructor(private router: Router, private _loading: LoadingPanelService,
              private readonly _tis: TipoIdentificacionService,
              private datasetDinamicoService: DatasetDinamicoService) {
    this.getTipoIdentificacion();
  }

  ngOnInit(): void {
    this.getConfigTable();
  }

  ngAfterViewInit(): void {
    if (this.customTableComponent && !this.responses.length) {
      setTimeout(() =>this.customTableComponent.data = [], 300);
    }
  }

  private getConfigTable(): void {
    this.configTable = {
      columns: [
        {
          field: 'tipoIdentificacion',
          header: 'Tipo identificación',
          class: 'font-13 py-3',
          width: '20em',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: null
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'identificacion',
          header: 'Identificación',
          class: 'font-13 py-3',
          width: '20em',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: null
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'nombreCompleto',
          header: 'Nombre completo',
          class: 'font-13 py-3',
          width: '25em',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: null
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'search',
          header: '',
          icon: 'pi pi-search',
          width: '0rem',
          class: 'pt-2 pb-2 pr-1 p-button-outlined',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: any, data: ISisbenConsultaResponse) => this.showDetalle(data)
        }
      ],
      settings: {
        table: {
          rows: 8
        }
      } as ISettings
    } as ICustomTable;
  }

  getSearchValues($event: IsearchJefeHogar) {
    this.consultaSisben($event.identificacion, +$event.tipoIdentificacion);
  }

  clearSearch() {
    this.customTableComponent.data = [];
    this.buscarComponent.existData = false;
  }

  showDetalle(data: ISisbenConsultaResponse) {
    this.router.navigate(['/tramites/detalle', data.id]).then();
  }


  //#region call api

  consultaSisben(identificacion: string, tipoIdentificacion: number) {
    this._loading.show();
    this.datasetDinamicoService.consultaSisben(tipoIdentificacion, identificacion).subscribe({
      next: data => {
        this.responses = data;
        this.customTableComponent.data = this.responses;
        this.customTableComponent.totalRecords = this.responses.length;
      }, complete: () => {
        this._loading.hide();
      }, error: () => {

      }
    });
  }

  private getTipoIdentificacion() {
    this._tis.getTipoIdentificaciones().subscribe({
      next: data => {
        this.tiposIdentificaciones = data;
      }
    })
  }

//#endregion call api
}

